export default "__VITE_ASSET__C8CGv$1Z__"